/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import MESSANGER from '../BaseComponent/MESSANGER'
import $ from 'jquery'
import InputMask from 'react-input-mask'

class ReportTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      template: [],
      printInfo: [],
      editModal: false,
      deleteModal: false
    }
  }

  getAllTemplate = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            template: response.data.object.result,
            countAll: response.data.object.countAll
          })
          $('.showBaseTable').fadeIn()
        } else {
          this.setState({
            template: [],
            countAll: ''
          })
          $('.showBaseTable').fadeOut()
        }
      })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')

    this.getAllTemplate()
  }

  activate = (enabled, id) => {
    if (enabled) {
      let data = {
        id: id
      }

      http
        .post(`${MESSANGER.MESSAGING_TYPE_DISABLE_TEMPLATE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getAllTemplate()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    } else {
      let data = {
        id: id
      }

      http
        .post(`${MESSANGER.MESSAGING_TYPE_ENABLE_TEMPLATE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error === null) {
            this.getAllTemplate()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  edit = (id, title, content, code, sortOrder) => {
    this.setState({
      id,
      title,
      content,
      code,
      sortOrder,
      editModal: !this.state.editModal
    })
  }
  editToggle = () => {
    this.setState({
      id: '',
      title: '',
      content: '',
      coder: '',
      sortOrder: '',
      editModal: !this.state.editModal
    })
  }
  editCancel = () => {
    this.editToggle()
  }

  editOk = () => {
    let {id, title, content, code, sortOrder} = this.state
    let titleError = false
    let contentError = false
    let codeError = false
    let sortOrderError = false
    let formError = false
    if (title === '') {
      message.error('عنوان وارد شود')
      titleError = true
      formError = true
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }
    if (content === '') {
      message.error('متن وارد شود')
      contentError = true
      formError = true
    } else {
      if (!contentError) {
        this.setState({
          error: ''
        })
      }
    }
    if (code === '') {
      message.error('کد وارد شود')
      codeError = true
      formError = true
    } else {
      if (!codeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        id,
        title,
        content,
        code,
        sortOrder
      }
      http.post(`${MESSANGER.MESSAGING_TYPE_EDIT_TEMPLATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('متن از پیش تعریف شده ویرایش شد')
          this.getAllTemplate()
          this.editToggle()
        } else {
          // message.error(response.data.description)
        }
      })
    }
  }

  delete = (id, title) => {
    this.setState({
      id,
      title,
      deleteModal: !this.state.deleteModal
    })
  }
  toggleCancelDelete = () => {
    this.setState({
      id: '',
      title: '',
      deleteModal: !this.state.deleteModal
    })
  }
  deleteCancel = () => {
    this.toggleCancelDelete()
  }
  deleteOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    http.post(`${MESSANGER.MESSAGING_TYPE_DELETE_TEMPLATE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('متن با موفقیت حذف شد')
        this.getAllTemplate()
        this.toggleCancelDelete()
      } else {
      }
    })
  }

  changeDropDown(data) {
    this.setState({
      template: data,
      lengthProducts: this.state.total
    })
  }

  onResultFetched(data) {
    this.setState({
      template: data
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  exportExcel = () => {
    http
      .get(
        `${MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'عنوان', 'متن', 'وضعیت']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست متن های از پیش تعریف شده پیام رسان"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((temp, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{temp.title}</td>
                  <td>{temp.content}</td>
                  <td>{temp.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست متن های از پیش تعریف شده پیام رسان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'content'}
                field={'content'}
                title={'متن'}
                width="400px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>پیام رسان</li>
            <li>پیام های از پیش تعریف شده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/base/messanger/addTemplate"
                  url={MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>متن</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.template.map((temp, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{temp.title}</td>
                      <td>{temp.content}</td>
                      <td>
                        <button onClick={() => this.activate(temp.enabled, temp.id)}>
                          {temp.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.edit(temp.id, temp.title, temp.content, temp.code, temp.sortOrder)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(temp.id, temp.title)}>
                          <img src={require('../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={MESSANGER.MESSAGING_TYPE_REPORT_TEMPLATE}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.deleteModal} toggle={this.toggleCancelDelete} size="sm">
          <ModalHeader toggle={this.toggleCancelDelete}>حذف انبار</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف متن {this.state.title} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.editToggle} size="sm">
          <ModalHeader toggle={this.editToggle}>ویرایش متن آماده پیام رسان</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>
                  {' '}
                  عنوان : <span className="requireFiled">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="title"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.title}
                  id="title"
                />
              </div>

              <div className="formComponent">
                <label>
                  {' '}
                  متن : <span className="requireFiled">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="content"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.content}
                  id="content"
                />
              </div>

              <div className="formComponent">
                <label>
                  {' '}
                  کد : <span className="requireFiled">*</span>
                </label>

                <InputMask
                  autocomplete="off"
                  id="code"
                  name="code"
                  placeholder="عدد"
                  className="form-control"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.code}
                  mask="999999999"
                  maskChar={null}
                />
              </div>

              <div className="formComponent">
                <label> ترتیب نمایش : </label>
                <InputMask
                  autocomplete="off"
                  id="sortOrder"
                  name="sortOrder"
                  placeholder="عدد"
                  className="form-control"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.sortOrder}
                  mask="999999999"
                  maskChar={null}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportTemplate
